var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJira(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_260_1720)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.8303 0.5H13.347C13.347 2.11427 13.9883 3.66241 15.1297 4.80388C16.2712 5.94533 17.8193 6.58659 19.4336 6.58659H21.9174V8.98473C21.9195 12.3432 24.6415 15.0653 28 15.0675V1.66968C28 1.02387 27.4765 0.5 26.8303 0.5Z",
    fill: "#2684FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1589 7.21973H6.67567C6.67777 10.5782 9.39974 13.3003 12.7583 13.3025H15.2421V15.7083C15.2464 19.0668 17.9703 21.787 21.3287 21.787V8.38962C21.3287 7.74358 20.805 7.21973 20.1589 7.21973Z",
    fill: "url(#paint0_linear_260_1720)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4833 13.9326H0C0 17.2942 2.72516 20.0192 6.08658 20.0192H8.57816V22.4173C8.58038 25.7727 11.2976 28.4935 14.6531 28.4998V15.1024C14.6531 14.4564 14.1294 13.9326 13.4833 13.9326Z",
    fill: "url(#paint1_linear_260_1720)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_260_1720",
    x1: 21.0402,
    y1: 7.24316,
    x2: 15.3395,
    y2: 13.1917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_260_1720",
    x1: 14.7506,
    y1: 13.9989,
    x2: 8.15623,
    y2: 20.4869,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_260_1720"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJira);
export default __webpack_public_path__ + "static/media/jira.435a2c17769de475f61e1ffdb0a8d770.svg";
export { ForwardRef as ReactComponent };